import { Navigate } from "react-router";

import { Loader, Info } from "components/elements";
import { PageContent } from "components/layout";
import { usePlatforms } from "hooks/tivoDevices";

import { MAIN_ROUTE } from "../constants";
import { getPageMode } from "./utils";

export function TiVoPublicationsRedirect() {
  const { data, isLoading: loading, error } = usePlatforms();
  const mode = getPageMode();
  const platforms = data?.results || [];
  const defaultPlatformId = platforms[0]?.id;

  if (loading || error) {
    return (
      <PageContent>
        {loading ? <Loader /> : <Info type="error">{error!.message}</Info>}
      </PageContent>
    );
  }

  return (
    <Navigate
      to={`/${MAIN_ROUTE}/publication/${mode}/${defaultPlatformId}`}
      replace
    />
  );
}
